import RefreshIcon from '@mui/icons-material/Refresh';
import './loading.scss';

export default
function LoadingIcon() {

    return (
        <RefreshIcon className="loading-icon" />
    )
}